import axios from "axios";

export default function generate(Service) {
  function checkRequests(name, key) {
    state.currentRequests[name] = state.currentRequests[name] || {};
    if (state.currentRequests[name][key]) {
      return false;
    }
    state.currentRequests[name][key] = true;
    return true;
  }
  function removeRequests(name, key) {
    if (state.currentRequests[name]) {
      state.currentRequests[name][key] = false;
      delete state.currentRequests[name][key];
    }
  }

  const state = {
    list: [],
    page: {},
    item: {},
    pageLimit: 25,
    cursor: {},
    currentRequests: {}
  };
  const getters = {
    getList(state) {
      return state.list;
    },
    getItem(state) {
      return state.item;
    },
    getPage(state) {
      return { ...state.page, limit: state.pageLimit };
    },
    getCursor(state) {
      return state.cursor;
    },
    getPageLimit(state) {
      return state.pageLimit;
    }
  };
  const actions = {
    getList({ commit, getters }, { params = {}, onSuccess = () => {} }) {
      if (getters["getPageLimit"]) {
        params.limit = params.limit || getters["getPageLimit"];
        if (params.limit > 0) {
          commit("setPageLimit", params.limit);
        }
      }
      let key = JSON.stringify(params);
      if (checkRequests("getList", key)) {
        return Service.getList(params, ({ list, page, cursor }) => {
          commit("setList", {
            list,
            page,
            cursor
          });
          onSuccess({ list, page, cursor });
        }).finally(() => removeRequests("getList", key));
      }
    },
    fetchData({ commit }, { url }) {
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(response => {
            const items = response.data.items;
            const cursor = response.data.cursor;
            commit("setList", { list: items, page: {}, cursor: cursor });
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    create(_, { item, onSuccess, onError, errorHandler, options }) {
      return Service.create(
        {
          ...item
        },
        onSuccess ?? function() {},
        onError ?? function() {},
        errorHandler ?? function() {},
        options ?? {}
      );
    },

    update(_, { item, onSuccess, onError, errorHandler, options }) {
      return Service.update(
        { ...item },
        onSuccess ?? function() {},
        onError ?? function() {},
        errorHandler ?? function() {},
        options ?? {}
      );
    },
    get(
      { commit },
      {
        id,
        params = {},
        options = { needReset: true },
        onError = () => {},
        onSuccess = () => {}
      }
    ) {
      if (options.needReset) {
        commit("set", {
          item: {}
        });
      }
      return Service.get(
        { id, ...params },
        item => {
          onSuccess(item);
          commit("set", {
            item
          });
        },
        onError
      );
    },
    delete(
      { commit },
      { id, params = {}, onSuccess, onError, errorHandler, options }
    ) {
      return Service.delete(
        { id, ...params },
        data => {
          commit("set", {
            item: {}
          });
          onSuccess(data);
        },
        onError ?? function() {},
        errorHandler ?? function() {},
        options ?? {}
      );
    },
    deleteList(
      _,
      { ids, onSuccess, onError, errorHandler, options, record_type }
    ) {
      return Service.deleteList(
        { ids, record_type },
        onSuccess ?? function() {},
        onError ?? function() {},
        errorHandler ?? function() {},
        options ?? {}
      );
    }
  };

  const mutations = {
    setList(state, { list, page, cursor }) {
      state.list = list;
      state.page = page;
      state.cursor = cursor;
    },
    setPageLimit(state, limit) {
      state.pageLimit = limit;
    },
    setCursor(state, cursor) {
      state.nextUrl = cursor.next;
      state.prevUrl = cursor.prev;
    },
    set(state, { item }) {
      state.item = item;
    }
  };
  return {
    state,
    getters,
    actions,
    mutations
  };
}
